import React from 'react';
import './CSS/Services.css';

function Services() {
  return (
    <section id="services" className="services-section">
      <h1>Nuestros Servicios</h1>
      <div className="services-container">
        <div className="service-card">
          <h2>Vacunación y desparasitación</h2>
          <p>Vacunamos y desparasitamos a tu mascota para prevenir enfermedades.</p>
        </div>
        <div className="service-card">
          <h2>Cirugía</h2>
          <p>Contamos con un equipo especializado en cirugía y anestesia.</p>
        </div>
        <div className="service-card">
          <h2>Diagnóstico por imagen</h2>
          <p>Disponemos de areas adaptadas para radiografía, ecografía y endoscopia.</p>
        </div>
        <div className="service-card">
          <h2>Hospitalización</h2>
          <p>Ofrecemos la mejor atención y cuidado posible en caso de que tu compañero necesite quedarse hospitalizado.</p>
        </div>
        <div className="service-card">
          <h2>Cuidados geriátricos</h2>
          <p>Organizamos un plan específico para la última etapa de tu pequeño basado en la prevención de enfermedades y retrasando las afecciones propias de la edad.</p>
        </div>
        <div className="service-card">
          <h2>¿Vas a viajar con tu mascota?</h2>
          <p>Contáctanos y realizaremos los trámites necesarios para que todo vaya correctamente.</p>
        </div>
      </div>
    </section>
  );
}

export default Services;